import { IconChevronDown, IconUserCircle } from '@tabler/icons-react';
import { LoadingSpinner } from '@petseo/shared';
import { useProfileSelectorContext } from '@/contexts/ProfileSelectorContext';
import { useSelectedProfile, useHasProfiles, useProfileError } from '@/store/profileStore';
import { useProfileSelector } from '@/hooks/profile/useProfileSelector';

export function ProfileSelectorTrigger() {
  const { isOpen, setIsOpen } = useProfileSelectorContext();
  const { isLoading, isError } = useProfileSelector();
  const selectedProfile = useSelectedProfile();
  const hasProfiles = useHasProfiles();
  const profileError = useProfileError();

  const displayName = selectedProfile?.name || 'Wybierz profil';
  const avatarLetter = selectedProfile?.name?.[0]?.toUpperCase() || 'P';

  return (
    <button
      type="button"
      className="btn d-flex align-items-center gap-2 px-3"
      disabled={isError || !!profileError}
      onClick={() => setIsOpen(!isOpen)}
      style={{
        background: 'var(--tblr-bg-surface)',
        border: '1px solid var(--tblr-border-color)',
        borderRadius: 'var(--tblr-border-radius)',
        minWidth: '380px',
        height: '40px',
        transition: 'all 0.2s ease',
      }}>
      {isLoading ? (
        <LoadingSpinner size="sm" />
      ) : (
        <>
          {selectedProfile?.profilePhotoUrl ? (
            <span className="avatar avatar-sm" style={{ backgroundImage: `url(${selectedProfile.profilePhotoUrl})` }} />
          ) : (
            <span className="avatar avatar-sm bg-primary-lt text-primary">{hasProfiles ? avatarLetter : <IconUserCircle size={20} />}</span>
          )}
          <span className="d-none d-md-block fw-medium text-truncate" style={{ maxWidth: '280px' }}>
            {displayName}
          </span>
          <IconChevronDown
            size={16}
            className="text-secondary ms-auto"
            style={{
              transition: 'transform 0.2s ease',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </>
      )}
    </button>
  );
}
